export default "__VITE_ASSET__BIOwBow2__"